import type { SourcingFlowKind } from "@shared/labs/sourcing";
import { Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { explorationShareLink } from "./lib";

/**
 * "Copiar link" — copies a shareable deep-link to this run. Any Labs co-worker who
 * opens it lands straight on these results (the read is owner-shared and free); it
 * never enters their history and they can't re-run or edit it.
 */
export function ShareLinkButton({
  explorationId,
  kind,
}: {
  explorationId: string;
  kind: SourcingFlowKind;
}) {
  const { toast } = useToast();
  async function copy() {
    try {
      await navigator.clipboard.writeText(explorationShareLink(explorationId, kind));
      toast({
        title: "Link copiado",
        description: "Qualquer pessoa do Labs com este link verá esta lista.",
      });
    } catch {
      toast({
        title: "Não foi possível copiar",
        description: "Copie o endereço da página manualmente.",
        variant: "destructive",
      });
    }
  }
  return (
    <Button variant="outline" size="sm" onClick={copy}>
      <Link2 /> Copiar link
    </Button>
  );
}
